/* eslint-disable no-param-reassign */
import { add, remove } from "shared/lib/arrayUtils"

import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export interface RedirectLocationReducerState {
  scrollPreventedBy: string[]
}

const initialState: RedirectLocationReducerState = {
  scrollPreventedBy: []
}

function preventScrollHandler(
  state: RedirectLocationReducerState,
  action: PayloadAction<{ id: string }>
) {
  const { id } = action.payload
  state.scrollPreventedBy = add(id, state.scrollPreventedBy)
}

function allowScrollHandler(
  state: RedirectLocationReducerState,
  action: PayloadAction<{ id: string }>
) {
  const { id } = action.payload
  state.scrollPreventedBy = remove(id, state.scrollPreventedBy)
}

const scrollSlice = createSlice({
  name: "scroll",
  initialState,
  reducers: {
    preventScroll: preventScrollHandler,
    allowScroll: allowScrollHandler
  }
})

export const { preventScroll, allowScroll } = scrollSlice.actions
const { actions } = scrollSlice
export { actions }

export default scrollSlice.reducer
